export default __webpack_public_path__ + "static/media/tr.52e1e604.svg";